export default class ErrorCdMsgConstants {
  // CSV機能のエラーコードとメッセージ =====================================================================
  /** CSVアップロードに失敗しましたエラーコード。 */
  static FUNC_FAILED_CSV_UPLOAD_ERR_CD = 'AAC002'
  /** CSVアップロードに失敗しましたエラーメッセージ。 */
  static FUNC_FAILED_CSV_UPLOAD_ERR_MSG =
    'アップロードできませんでした。再読み込みし、再試行してください。'
  /** テーブルの上限を超えたデータのエラーメコード。 */
  static TOTAL_RECORDS_LIMIT_IN_DB_EXCEEDED_ERR_CD = 'ZAZ001'

  /** CSVインポート失敗エラーコード。 */
  static FUNC_FAILED_CSV_IMPORT_ERR_CD = 'AAH001'
  /** CSVインポート失敗のエラーメッセージ。 */
  static FUNC_FAILED_CSV_IMPORT_ERR_MSG = 'インポートできませんでした。'

  /** ファイルのプレフィックスが正しくない場合のエラーコード。 */
  static FUNC_CSV_FILE_ARE_UNSPECIFIED_PREFIX_ERR_CD = 'ABC001'
  /** ファイルのプレフィックスが正しくない場合のエラーメッセージ。 */
  static FUNC_CSV_FILE_ARE_UNSPECIFIED_PREFIX_ERR_MSG =
    'アップロードできませんでした。不明なファイルを取消し、アップロードしてください。'
  /** CSV 空ファイルのエラーコード。 */
  static FUNC_CSV_FILE_EMPTY_ERR_CD = 'ABC002'
  /** 空の CSV ファイルに関するエラーメッセージ。 */
  static FUNC_CSV_FILE_EMPTY_ERR_MSG = 'ファイルが空です。空ファイルを取消してください。'
  /** 変更されたCSVファイルのエラーコード。 */
  static FUNC_CSV_FILE_MODIFIED_ERR_CD = 'ABC003'
  /** 変更されたCSVファイルへのエラーメッセージ。 */
  static FUNC_CSV_FILE_MODIFIED_ERR_MSG = 'アップロードしたファイルに変更があります。エラーファイルを×ボタンから削除し、再度アップロードしてください。'
  /** タスクタイプが未指定のエラーコード。 */
  static FUNC_CSV_FILE_TASK_TYPE_UNAVAILABLE_ERR_CD = 'ABC004'
  /** タスクタイプが未指定のエラーメッセージ。 */
  static FUNC_CSV_FILE_TASK_TYPE_UNAVAILABLE_ERR_MSG = 'タスクタイプが登録されていません。t-Sort仕分けの設定画面から登録を行ってください。'
  /** ファイルが見つからないエラーコード。 */
  static FUNC_CSV_FILE_NOT_FOUND_ERR_CD = 'ABC005'
  /** ファイルが見つからないエラーメッセージ。 */
  static FUNC_CSV_FILE_NOT_FOUND_ERR_MSG = 'アップロードしたファイルがありません。エラーファイルを×ボタンから削除し、再度アップロードしてください。'

  /** ファイル名の長さが制限を超えるファイルアップロードのエラーコード。 */
  static FILE_UPD_NAME_LENGTH_ERR_CD = 'AAC009';

  /** CSV種類マスタが見つからないエラーコード。 */
  static FILE_UPD_CSV_NO_UNKNOWN_ERR_CD = 'ACC001'
  // =======================================================================================================================

  // サーバー切断のエラー コードとメッセージ ===================================================================
  /** サーバー接続エラーコード。 */
  static FUNC_SERVER_CONNECTION_ERR_CD = 'ABA001'
  /** サーバー接続エラーメッセージ。 */
  static FUNC_SERVER_CONNECTION_ERR_MSG = '+Hubに接続されていません。'

  /** ネットワークプロキシサーバエラーコード。 */
  static FUNC_NETWORK_PROXY_SERVER_CONNECTION_ERR_CD = 'ABA002'
  /** ネットワークプロキシサーバエラーメッセージ。 */
  static FUNC_NETWORK_PROXY_SERVER_CONNECTION_ERR_MSG = 'ネットワークに接続されていません。Wi-Fiがオンになっていること、正しいネットワークに接続されていることを確認し、再試行してください。'

  /** サーバー切断エラーコード一覧。 */
  static SERVER_DISCONNECTION_ERR_CD_LIST = [ErrorCdMsgConstants.FUNC_SERVER_CONNECTION_ERR_CD, ErrorCdMsgConstants.FUNC_NETWORK_PROXY_SERVER_CONNECTION_ERR_CD]
  // =======================================================================================================================

  // ソケット接続エラーコードとメッセージ =====================================================================
  /** ソケット切断エラーコード。 */
  static FUNC_SOCKET_DISCONNECTION_ERR_CD = 1001;
  /** ソケット接続エラーコード。 */
  static FUNC_SOCKET_CONNECTION_ERR_CD = 1002;
  // =======================================================================================================================

  // バッチ一時保持のエラーコードとメッセージ ===================================================================
  /** タスク処理ステータスエラーコード。 */
  static FUNC_BATCH_TEMPORARY_HOLDING_ON_TASK_PROCESSING_ERR_CD = 'AAD007';
  /** タスク処理ステータスのエラーメッセージ。 */
  static FUNC_BATCH_TEMPORARY_HOLDING_ON_TASK_PROCESSING_ERR_MSG = '走行中のロボットがあります。ロボットの走行が終わるまでお待ちください。'

  /** タスク処理ステータスエラーコード。 */
  static FUNC_PARENT_BATCH_TEMPORARY_HOLDING_ON_TASK_PROCESSING_ERR_CD = 'AAD006';
  /** タスク処理ステータスのエラーメッセージ。 */
  static FUNC_PARENT_BATCH_TEMPORARY_HOLDING_ON_TASK_PROCESSING_ERR_MSG = '走行中のロボットがあります。ロボットの走行が終わるまでお待ちください。'
  // =======================================================================================================================

  // マッピングエラーコードとメッセージ ===================================================================
  /** 関数マッピング WMS アイテムが最大レコード数を超えているエラー コード。 */
  static FUNC_MAPPING_WMS_ITEM_EXCEEDS_MAX_RECORDS_ERR_CD = 'AAK001';
  /** 関数マッピング WMS アイテムが最大レコード数を超えているというエラー メッセージ。 */
  static FUNC_MAPPING_WMS_ITEM_EXCEEDS_MAX_RECORDS_ERR_MSG = '501列以上は登録ができません。500列以下にしてください。'
  // =======================================================================================================================

  // アップロードタイムアウトのエラーコードとメッセージ =========================================================
  /** アップロードタイムアウトエラーコード。 */
  static FUNC_UPLOAD_TIMEOUT_ERR_CD = 'ABC006'
  /** アップロードタイムアウトエラーメッセージ。 */
  static FUNC_UPLOAD_TIMEOUT_ERR_MSG = 'アップロード中です。しばらくお待ちください。反映は作業管理画面またはマスタ画面をご確認ください。'
  // =======================================================================================================================

  // ログインIDかパスワードに誤りがありますのエラーコードとメッセージ =========================================================
  /** ログインIDかパスワードに誤りがありますエラーコード。 */
  static FUNC_LOGIN_ID_OR_PASSWORD_INCORRECT_ERR_CD = 'ADB001'
  /** ログインIDかパスワードに誤りがありますエラーメッセージ。 */
  static FUNC_LOGIN_ID_OR_PASSWORD_INCORRECT_ERR_MSG = 'ログインIDかパスワードに誤りがあります。入力内容をご確認ください。'

  /** +Hub BASEログイン権限エラーコード。 */
  static FUNC_HUB_BASE_LOGIN_PERMISSION_ERR_CD = 'ADB002'
  /** +Hub BASEへのログイン権限がありません。 */
  static FUNC_HUB_BASE_LOGIN_PERMISSION_ERR_MSG = '+Hub BASEへのログイン権限がありません。'

  /** +Hub拠点ログイン制限エラーコード。 */
  static FUNC_HUB_LOCATION_LOGIN_RESTRICTED_ERR_CD = 'ADB003'
  /** +Hub拠点ログイン制限エラーメッセージ。 */
  static FUNC_HUB_LOCATION_LOGIN_RESTRICTED_ERR_MSG = 'こちらの拠点にログインできるアカウントではありません。マイアカウントをご確認ください。'
  // ========================================================================================================================
}



// WEBPACK FOOTER //
// ./src/constants/error-cd-msg.constants.js